import type { FC, PropsWithChildren } from 'react';
import { useEffect } from 'react';

import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { Meta } from '@xing-com/typography';

import { usePagination } from '../../hooks/use-pagination';
import { scrollToTop } from '../../utils';
import { Breadcrumbs } from '../breadcrumbs/breadcrumbs';
import { MetaData } from '../meta-data';

import * as Styled from './subpage-layout.styles';

type SubpageLayoutProps = {
  headerText: string;
  description?: string;
  overrideBreadcrumbsNames?: { [route: string]: () => string };
};

export const SubpageLayout: FC<PropsWithChildren<SubpageLayoutProps>> = ({
  headerText,
  description,
  children,
  overrideBreadcrumbsNames,
}) => {
  const { isLoggedOut } = useLoginState();
  useEffect(() => scrollToTop(), []);
  const { activePage, isFirstPage } = usePagination();
  const currentUrl = window.location;

  const showBreadcrumbs = isLoggedOut;

  return (
    <Styled.SubpageLayout $showBreadcrumbs={showBreadcrumbs}>
      <MetaData
        index={isFirstPage}
        title={headerText}
        description={description ?? headerText}
        canonicalUrl={activePage ? currentUrl : undefined}
      />
      {showBreadcrumbs && (
        <Breadcrumbs overrideNames={overrideBreadcrumbsNames} />
      )}
      <Styled.HeaderLayout>
        <Styled.HeaderLayoutHeadline
          size="xxxlarge"
          sizeWide="xxxlarge"
          sizeConfined="xxxlarge"
        >
          {headerText}
        </Styled.HeaderLayoutHeadline>
        <Meta size="large">{description}</Meta>
      </Styled.HeaderLayout>
      {children}
    </Styled.SubpageLayout>
  );
};
